import React from 'react'

import {
  Page,
  LoaderIcon,
} from '../styles'

const Loading = () => (
  <Page>
    <LoaderIcon />
  </Page>
)

export default Loading



// WEBPACK FOOTER //
// ./src/views/misc/Loading.jsx